import type { Translation } from './types';
import { hideArrayProperties } from './types';

export const es: Translation = hideArrayProperties<Translation>({
  meta: {
    title: 'Aletiq \u2014 Tu IA construye. Aletiq verifica.',
    description:
      'Tu agente de IA construye tu sitio web y lo verifica autom\u00e1ticamente con Aletiq. Doble verificaci\u00f3n para aplicaciones web generadas por IA.',
    ogTitle: 'Aletiq \u2014 Tu IA construye. Aletiq verifica.',
    ogDescription: 'Doble verificaci\u00f3n para aplicaciones web generadas por IA. Autom\u00e1tico, seguro, sin esfuerzo.',
  },
  nav: {
    home: 'Inicio',
    howItWorks: 'C\u00f3mo funciona',
    useCases: 'Casos de uso',
    security: 'Seguridad',
    pricing: 'Precios',
    contact: 'Contacto',
    blog: 'Blog',
    cta: 'Empezar gratis',
    languageSwitch: 'ES',
  },

  // \u2500\u2500 Hero \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  hero: {
    badge: 'Para Claude Code, Cursor y Codex v\u00eda MCP',
    headlineLine1: 'Tu IA construye \u2014',
    headlineLine2: 'Aletiq verifica',
    subheadline:
      'Tu agente de IA escribe c\u00f3digo m\u00e1s r\u00e1pido de lo que puedes revisar. Aletiq verifica autom\u00e1ticamente, env\u00eda feedback al agente, y este corrige en el acto \u2014 t\u00fa solo ves el resultado final.',
    ctaPrimary: 'Solicitar acceso anticipado',
    ctaSecondary: 'C\u00f3mo funciona',
    chatFlow: [
      { role: 'user', text: 'Constr\u00fayeme una tienda online con checkout' },
      { role: 'agent', text: 'Construyendo p\u00e1gina de producto, carrito y checkout...' },
      { role: 'agent', text: 'aletiq --verify "prueba el checkout" --page /checkout' },
      { role: 'aletiq', text: 'Datos de prueba preparados: producto + direcci\u00f3n completados', status: 'pass' },
      { role: 'aletiq', text: 'El bot\u00f3n de checkout no responde en m\u00f3vil', status: 'fail' },
      { role: 'agent', text: 'Error detectado \u2014 corrigiendo \u00e1rea t\u00e1ctil...' },
      { role: 'aletiq', text: 'Re-run: Checkout completado exitosamente', status: 'pass' },
    ],
    demoLines: [
      { type: 'user', text: 'Constr\u00fayeme una tienda online con checkout' },
      { type: 'blank', text: '' },
      { type: 'agent', text: 'Construyo p\u00e1gina de producto, carrito y checkout.' },
      { type: 'blank', text: '' },
      { type: 'tool-call', text: 'aletiq --verify "prueba el checkout" --page /checkout' },
      { type: 'blank', text: '' },
      { type: 'pass', text: 'Datos de prueba preparados: producto + direcci\u00f3n completados' },
      { type: 'pass', text: 'Navegaci\u00f3n: todos los enlaces funcionan' },
      { type: 'fail', text: 'El bot\u00f3n de checkout no responde en m\u00f3vil' },
      { type: 'blank', text: '' },
      { type: 'agent', text: 'Error detectado \u2014 corrigiendo \u00e1rea t\u00e1ctil...' },
      { type: 'blank', text: '' },
      { type: 'tool-call', text: 'aletiq --verify "re-run" (gratis)' },
      { type: 'blank', text: '' },
      { type: 'pass', text: 'Re-run: Checkout completado exitosamente' },
      { type: 'pass', text: '3/3 verificaciones superadas' },
    ],
  },

  // \u2500\u2500 Works With \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  worksWith: {
    subtitle: 'Integraci\u00f3n',
    heading: 'Mejor con',
    headingHighlight: 'Claude Code',
    description: 'Aletiq usa MCP \u2014 el est\u00e1ndar abierto para integraci\u00f3n de herramientas. Claude Code tiene hooks que llaman a Aletiq autom\u00e1ticamente despu\u00e9s de cada cambio. Cursor y Codex funcionan mediante reglas.',
    agents: [
      { name: 'Claude Code', logo: '/images/agents/claude-code.svg' },
      { name: 'Cursor', logo: '/images/agents/cursor.svg' },
      { name: 'Codex', logo: '/images/agents/codex.svg' },
      { name: 'Windsurf', logo: '/images/agents/windsurf.svg' },
      { name: 'Cline', logo: '/images/agents/cline.svg' },
      { name: 'Continue', logo: '/images/agents/continue.svg' },
    ],
  },

  // \u2500\u2500 How It Works (Homepage short version) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  howItWorks: {
    label: 'C\u00f3mo funciona',
    heading: 'C\u00f3mo',
    headingHighlight: 'funciona',
    intro: 'T\u00fa describes lo que quieres. Tu agente de IA lo construye, lo verifica con Aletiq \u2014 y t\u00fa ves el resultado.',
    steps: [
      {
        number: '01',
        title: 'T\u00fa describes',
        description: 'Dile a tu agente de IA lo que necesitas. Con tus propias palabras, como en una conversaci\u00f3n.',
      },
      {
        number: '02',
        title: 'Tu agente construye y verifica',
        description: 'El agente construye tu funcionalidad, llama a Aletiq, recibe feedback \u2014 y corrige los problemas en el acto.',
      },
      {
        number: '03',
        title: 'T\u00fa ves el resultado',
        description: 'Aletiq devuelve un veredicto claro a tu agente: aprobado, atenci\u00f3n necesaria o fallido \u2014 directamente en tu flujo de trabajo.',
      },
    ],
    linkText: 'M\u00e1s informaci\u00f3n',
    linkButton: 'Ver detalles',
  },

  // \u2500\u2500 Why Aletiq (replaces Verification Levels) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  whyAletiq: {
    label: '\u00bfPor qu\u00e9 Aletiq?',
    heading: 'Por qu\u00e9 los equipos',
    headingHighlight: 'eligen Aletiq',
    cards: [
      {
        icon: '\ud83d\udcbb',
        title: 'Se ejecuta en tu m\u00e1quina',
        description: 'El runner de Aletiq prueba directamente en localhost \u2014 cero latencia, sin necesidad de deploy. Tu agente recibe feedback en segundos, no en minutos.',
      },
      {
        icon: '\ud83d\udd04',
        title: 'Ciclo cerrado de feedback',
        description: 'Aletiq encuentra un error, tu agente lo corrige de inmediato \u2014 sin que t\u00fa tengas que intervenir. Incluso los datos de prueba se preparan autom\u00e1ticamente.',
      },
      {
        icon: '\ud83d\udd12',
        title: 'Tus datos se quedan en local',
        description: 'Ning\u00fan servidor en la nube ve tu c\u00f3digo. El runner se ejecuta en tu m\u00e1quina \u2014 eso hace que Aletiq sea econ\u00f3mico para nosotros y seguro para ti.',
      },
      {
        icon: '\ud83d\udeaa',
        title: 'No puede hacer trampa',
        description: 'Tu agente de programaci\u00f3n tiene acceso total \u2014 atascado en un bot\u00f3n roto, puede saltarse la interfaz y fingir una prueba aprobada. Aletiq solo ve lo que ven tus usuarios: el navegador. Si algo est\u00e1 roto, Aletiq no puede fingir que funciona.',
      },
      {
        icon: '\ud83c\udfaf',
        title: 'Veredictos claros',
        description: 'Tu agente ejecuta aletiq --verify y obtiene un resultado inequ\u00edvoco: aprobado o fallido \u2014 con detalles concretos para la correcci\u00f3n.',
      },
    ],
  },

  // \u2500\u2500 Use Cases (Homepage cards) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  useCases: {
    label: 'Casos de uso',
    heading: 'Lo que Aletiq',
    headingHighlight: 'verifica por ti',
    description: 'Sin importar lo que construya tu agente de IA \u2014 Aletiq verifica que funcione.',
    viewAllButton: 'Ver todos los escenarios',
    cards: [
      {
        slug: 'online-shop',
        icon: '\ud83d\uded2',
        title: '\u00bfFunciona mi checkout?',
        description: 'Tu agente construy\u00f3 una tienda online. Aletiq verifica que los clientes puedan ir del carrito al pedido completado.',
      },
      {
        slug: 'responsive',
        icon: '\ud83d\udcf1',
        title: '\u00bfSe ve bien en m\u00f3vil?',
        description: 'Aletiq abre tu sitio en diferentes tama\u00f1os de pantalla y verifica que todo se muestre correctamente.',
      },
      {
        slug: 'contact-form',
        icon: '\u2709\ufe0f',
        title: '\u00bfFunciona el formulario de contacto?',
        description: 'Aletiq completa tu formulario, lo env\u00eda y verifica que el mensaje llegue.',
      },
      {
        slug: 'navigation',
        icon: '\ud83e\udded',
        title: '\u00bfFunciona la navegaci\u00f3n?',
        description: 'Aletiq navega por tu men\u00fa y verifica que todos los enlaces lleven al destino correcto.',
      },
    ],
  },

  // \u2500\u2500 CTA \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  cta: {
    headline: '\u00bfListo?',
    headlineHighlight: 'Empieza gratis',
    button: 'Empezar gratis \u2192',
    card: {
      title: 'Empieza gratis',
      description: '50 verificaciones al mes. Re-runs ilimitados. Sin tarjeta de cr\u00e9dito.',
      link: 'Ver todos los planes \u2192',
    },
  },

  // \u2500\u2500 Proof Bar \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  proofBar: {
    badges: [
      { icon: '\ud83d\udd01', text: 'Re-runs siempre gratis' },
      { icon: '\ud83e\udde0', text: 'Efecto memoria muscular' },
      { icon: '\ud83e\udd16', text: 'Cero esfuerzo manual' },
      { icon: '\ud83d\udcb0', text: 'Hasta un 91% m\u00e1s barato' },
    ],
  },

  // \u2500\u2500 Muscle Memory \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  muscleMemory: {
    label: 'Memoria muscular',
    heading: 'Prueba una vez,',
    headingHighlight: 'protegido para siempre',
    description:
      'Aletiq recuerda cada prueba. Cada nuevo build se verifica autom\u00e1ticamente contra todas las pruebas anteriores \u2014 gratis. Tu red de seguridad crece con cada funcionalidad, sin que tengas que hacer nada.',
    steps: [
      { number: 'Semana 1', label: 'Formulario de contacto creado', checks: '4 pruebas' },
      { number: 'Semana 2', label: '+ Checkout a\u00f1adido', checks: '11 pruebas' },
      { number: 'Semana 4', label: '+ Blog y Dashboard', checks: '31 pruebas' },
      { number: 'Semana 8', label: '+ Pago y Login', checks: '47 re-runs gratis' },
    ],
    caption: 'Las pruebas nuevas cuestan tokens. Los 47 re-runs: $0.',
  },

  // \u2500\u2500 Token Savings \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  tokenSavings: {
    label: 'Costo y eficiencia',
    heading: '',
    headingHighlight: '91% m\u00e1s barato que las pruebas manuales',
    description:
      'Tu agente de IA escribe c\u00f3digo m\u00e1s r\u00e1pido de lo que puedes revisar. Sin Aletiq, pruebas todo manualmente \u2014 o encuentras errores en producci\u00f3n. Con Aletiq: autom\u00e1tico, instant\u00e1neo, hasta un 91% m\u00e1s barato.',
    comparison: [
      { label: 'Pruebas manuales', tokens: 'T\u00fa revisas cada build', bar: 30 },
      { label: 'Sin verificaci\u00f3n', tokens: 'Errores en producci\u00f3n \u2192 correcci\u00f3n costosa', bar: 15 },
      { label: 'Con Aletiq', tokens: 'Autom\u00e1tico, re-runs gratis', bar: 100, highlight: true },
    ],
    caption: 'Se ejecuta localmente en tu m\u00e1quina + estrategia de modelo mixto (re-runs con modelo r\u00e1pido) = hasta un 91% m\u00e1s barato.',
  },

  // \u2500\u2500 Sticky CTA \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  stickyCta: {
    text: 'Re-runs gratis',
    button: 'Empezar gratis',
  },

  // \u2500\u2500 Pricing \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  pricing: {
    label: 'Precios',
    title: 'Simple. Transparente. Justo.',
    popularBadge: 'M\u00e1s popular',
    allPlansLabel: 'Incluido en todos los planes',
    tiers: [
      {
        name: 'Free',
        price: '$0',
        period: 'para siempre',
        verifications: '100 verificaciones/mes',
        features: [
          'Verificaciones b\u00e1sicas (enlaces, formularios, dise\u00f1o)',
          'Re-runs ilimitados',
          'Un proyecto',
          'Soporte de la comunidad',
        ],
        cta: 'Empezar gratis',
      },
      {
        name: 'Builder',
        price: '$39',
        period: '/mes',
        verifications: '500 verificaciones/mes',
        features: [
          'Verificaciones extendidas (+ funcionalidad)',
          'Re-runs ilimitados',
          'Hasta 3 proyectos',
          'Soporte por email',
          'Excedente $0,03/verificaci\u00f3n',
        ],
        cta: 'Comenzar con Builder',
      },
      {
        name: 'Production',
        price: '$89',
        period: '/mes',
        verifications: '3.000 verificaciones/mes',
        features: [
          'Verificaciones completas (+ flujos de trabajo)',
          'Re-runs ilimitados',
          'Hasta 10 proyectos',
          'Acceso CI y API',
          'Cola prioritaria',
          'Excedente $0,05/verificaci\u00f3n',
        ],
        cta: 'Comenzar Production',
        popular: true,
      },
      {
        name: 'Enterprise',
        price: 'Personalizado',
        period: 'bajo solicitud',
        verifications: 'Cuota personalizada',
        features: [
          'Proyectos ilimitados',
          'SSO / SAML',
          'Espacio de trabajo en equipo',
          'Merge gating',
          'Pol\u00edticas de verificaci\u00f3n personalizadas',
          'Soporte dedicado + SLA',
        ],
        cta: 'Contactar con ventas',
        contactSales: true,
      },
    ],
    allPlansInclude: [
      'Re-runs ilimitados y gratuitos',
      'Runner local en tu m\u00e1quina',
      'Integraci\u00f3n MCP (Claude Code, Cursor, Codex)',
      'Preparaci\u00f3n autom\u00e1tica de datos de prueba',
    ],
    faq: {
      label: 'FAQ',
      title: 'Preguntas frecuentes',
      items: [
        {
          question: '\u00bfLos re-runs son realmente gratis?',
          answer: 'S\u00ed. Cada re-run de una prueba existente es completamente gratis \u2014 sin importar cu\u00e1ntas veces. Solo las verificaciones nuevas cuentan contra tu cuota.',
        },
        {
          question: '\u00bfQu\u00e9 cuenta como una verificaci\u00f3n?',
          answer: 'Cada llamada a aletiq --verify con un caso de prueba nuevo cuenta como una verificaci\u00f3n. Los re-runs de pruebas existentes son gratis.',
        },
        {
          question: '\u00bfPuedo cambiar de plan en cualquier momento?',
          answer: 'S\u00ed. Puedes cambiar tu plan en cualquier momento. La facturaci\u00f3n se ajusta proporcionalmente.',
        },
        {
          question: '\u00bfQu\u00e9 pasa cuando alcanzo mi l\u00edmite?',
          answer: 'Los re-runs siguen funcionando sin l\u00edmites. Las verificaciones nuevas se ponen en cola hasta tu pr\u00f3ximo ciclo de facturaci\u00f3n.',
        },
        {
          question: '\u00bfQu\u00e9 agentes de IA funcionan con Aletiq?',
          answer: 'Claude Code (v\u00eda hooks \u2014 integraci\u00f3n determin\u00edstica), Cursor (v\u00eda rules), Codex (v\u00eda AGENTS.md) y cualquier agente compatible con MCP.',
        },
        {
          question: '\u00bfNecesito tarjeta de cr\u00e9dito para el plan Free?',
          answer: 'No. El plan Free es gratis para siempre, sin tarjeta de cr\u00e9dito. 100 verificaciones al mes, re-runs ilimitados.',
        },
      ],
    },
  },

  // \u2500\u2500 How It Works (detail page) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  howItWorksPage: {
    title: 'C\u00f3mo funciona Aletiq',
    subtitle: 'Tu agente de IA construye. Aletiq verifica autom\u00e1ticamente. T\u00fa ves el resultado.',
    heroLabel: 'C\u00f3mo funciona',
    heroTitle: 'Tu agente construye \u2014',
    heroHighlight: 'Aletiq verifica',
    steps: [
      {
        number: '01',
        title: 'T\u00fa describes lo que quieres',
        description: 'Hablas con tu agente de IA \u2014 no directamente con Aletiq. Aletiq trabaja en segundo plano, invisible para ti.',
        details: [
          '"Constr\u00fayeme una tienda online con carrito de compras"',
          '"A\u00f1ade un formulario de contacto"',
          '"Crea una landing page para mi startup"',
        ],
      },
      {
        number: '02',
        title: 'Tu agente construye \u2014 y verifica autom\u00e1ticamente',
        description: 'El agente tiene Aletiq integrado como herramienta. Despu\u00e9s de cada funcionalidad, ejecuta aletiq --verify. Aletiq prueba, prepara datos de prueba y da feedback \u2014 el agente corrige en el acto.',
        details: [
          'Ciclo cerrado: verificar \u2192 feedback \u2192 corregir \u2192 re-verificar',
          'Datos de prueba preparados autom\u00e1ticamente (formularios, logins, pedidos)',
          'Sin intervenci\u00f3n necesaria \u2014 el agente y Aletiq lo resuelven juntos',
        ],
      },
      {
        number: '03',
        title: 'T\u00fa ves resultados claros',
        description: 'Aprobado, atenci\u00f3n necesaria o fallido \u2014 con detalles concretos de lo que se verific\u00f3. Tu agente puede reaccionar de inmediato.',
        details: [
          'Aprobado: Todo funciona como se esperaba',
          'Atenci\u00f3n: Algo parece sospechoso (ej. carga lenta)',
          'Fallido: Algo no funciona \u2014 Aletiq le dice a tu agente exactamente qu\u00e9',
        ],
      },
    ],
    resultLabels: {
      pass: 'Aprobado',
      warn: 'Atenci\u00f3n',
      fail: 'Fallido',
    },
  },

  // \u2500\u2500 Use Cases (detail page) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  useCasesPage: {
    title: 'Lo que Aletiq verifica por ti',
    subtitle: 'Sin importar lo que construya tu agente de IA \u2014 Aletiq verifica que funcione.',
    heroLabel: 'Casos de uso',
    heroTitle: 'Sin importar lo que construya tu agente \u2014',
    heroHighlight: 'Aletiq lo verifica',
    terminalLabel: 'Ejemplo en vivo',
    terminalTitle: 'As\u00ed se ve una verificaci\u00f3n',
    terminalDescription: 'Tu agente ejecuta aletiq --verify. Aletiq prepara datos de prueba, verifica todo y da feedback concreto.',
    scenariosLabel: 'Escenarios',
    scenariosTitle: 'Lo que tu agente construye \u2014',
    scenariosHighlight: 'Aletiq lo verifica',
    cards: [
      {
        slug: 'online-shop',
        icon: '\ud83d\uded2',
        title: 'Tienda online',
        whatYouSay: 'Constr\u00fayeme una tienda con carrito de compras',
        whatAletiqChecks: '\u00bfPueden los clientes agregar productos y completar la compra?',
      },
      {
        slug: 'landing-page',
        icon: '\ud83d\ude80',
        title: 'Landing Page',
        whatYouSay: 'Crea una landing page para mi startup',
        whatAletiqChecks: '\u00bfFuncionan todos los enlaces? \u00bfSe ve bien en m\u00f3vil?',
      },
      {
        slug: 'booking-system',
        icon: '\ud83d\udcc5',
        title: 'Sistema de reservas',
        whatYouSay: 'Necesito una herramienta para agendar citas',
        whatAletiqChecks: '\u00bfPueden los usuarios seleccionar y confirmar citas?',
      },
      {
        slug: 'dashboard',
        icon: '\ud83d\udcca',
        title: 'Dashboard',
        whatYouSay: 'Constr\u00fayeme un dashboard de clientes',
        whatAletiqChecks: '\u00bfSe cargan los datos? \u00bfFunciona la navegaci\u00f3n?',
      },
      {
        slug: 'blog',
        icon: '\ud83d\udcdd',
        title: 'Blog',
        whatYouSay: 'Crea un blog con comentarios',
        whatAletiqChecks: '\u00bfPueden los visitantes leer publicaciones y dejar comentarios?',
      },
      {
        slug: 'member-area',
        icon: '\ud83d\udd10',
        title: '\u00c1rea de miembros',
        whatYouSay: 'Construye un \u00e1rea de login para mis clientes',
        whatAletiqChecks: '\u00bfFuncionan el registro, login y recuperaci\u00f3n de contrase\u00f1a?',
      },
    ],
  },

  // \u2500\u2500 Security Page (replaces Architecture) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  securityPage: {
    title: 'Seguridad y privacidad',
    subtitle: 'Tus datos se quedan contigo. Siempre.',
    heroLabel: 'Seguridad',
    heroTitle: 'Tus datos se quedan',
    heroHighlight: 'contigo. Siempre.',
    architectureLabel: 'Arquitectura',
    architectureTitle: 'Todo se ejecuta en tu m\u00e1quina',
    architectureDescription: 'El runner de Aletiq se ejecuta localmente en tu m\u00e1quina. Tu c\u00f3digo, datos y pruebas nunca salen de tu red. Solo estad\u00edsticas de uso anonimizadas llegan a nuestros servidores.',
    points: [
      {
        icon: '\ud83c\udfe0',
        title: 'Tus datos se quedan contigo',
        description: 'Todas las pruebas se ejecutan en tu m\u00e1quina. Tu c\u00f3digo y tus datos nunca salen de tu red.',
      },
      {
        icon: '\ud83d\udc41\ufe0f',
        title: 'No vemos tu c\u00f3digo',
        description: 'Solo se analizan los resultados de pruebas y observaciones. Tu c\u00f3digo fuente permanece privado.',
      },
      {
        icon: '\ud83e\udd16',
        title: 'Tu agente, tu control',
        description: 'Aletiq solo hace lo que tu agente le pide. Sin acciones aut\u00f3nomas, sin accesos ocultos.',
      },
      {
        icon: '\ud83d\udd12',
        title: 'Comunicaci\u00f3n encriptada',
        description: 'Todas las conexiones est\u00e1n encriptadas. Tus datos est\u00e1n tan seguros en tr\u00e1nsito como en reposo.',
      },
    ],
  },

  // \u2500\u2500 Contact \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  contact: {
    title: 'Contacto',
    subtitle: 'Escr\u00edbenos \u2014 te respondemos r\u00e1pidamente',
    nameLabel: 'Nombre',
    emailLabel: 'Correo electr\u00f3nico',
    companyLabel: 'Empresa',
    messageLabel: 'Mensaje',
    submitButton: 'Enviar mensaje',
    salesHeading: '\u00bfPreguntas sobre Premium o equipos?',
    validation: {
      nameMin: 'El nombre debe tener al menos 2 caracteres',
      emailInvalid: 'Por favor ingresa un correo electr\u00f3nico v\u00e1lido',
      messageMin: 'El mensaje debe tener al menos 10 caracteres',
    },
    status: {
      success: 'Tu mensaje ha sido enviado. \u00a1Te responderemos pronto!',
      error: 'Algo sali\u00f3 mal. Por favor int\u00e9ntalo de nuevo m\u00e1s tarde.',
    },
  },
  earlyAccess: {
    title: 'Solicitar acceso anticipado',
    subtitle: 'Aletiq est\u00e1 en acceso anticipado. Incorporamos socios de dise\u00f1o manualmente para asegurarnos de que el producto encaje con tu forma de trabajar.',
    badge: 'Acceso anticipado',
    intro: 'Cu\u00e9ntanos qu\u00e9 est\u00e1s construyendo y c\u00f3mo lo verificas hoy. Si hay encaje, te contactaremos en 2 d\u00edas laborables con una configuraci\u00f3n privada.',
    trustBullets: [
      { icon: '\u2022', text: 'No se requiere tarjeta de cr\u00e9dito' },
      { icon: '\u2022', text: 'Plazas limitadas \u2014 estamos incorporando socios de dise\u00f1o' },
      { icon: '\u2022', text: 'Respuesta en 2 d\u00edas laborables' },
    ],
    form: {
      nameLabel: 'Tu nombre',
      emailLabel: 'Correo corporativo',
      emailHint: 'Usa un correo corporativo \u2014 nos ayuda a priorizar.',
      companyLabel: 'Empresa',
      stackLabel: 'Stack / framework',
      stackPlaceholder: 'p.ej. Next.js + Vercel, SvelteKit, Rails',
      goalLabel: '\u00bfQu\u00e9 quieres verificar?',
      goalPlaceholder: 'Brevemente: \u00bfqu\u00e9 flujos construye tu agente de IA y d\u00f3nde falla actualmente? (1\u20132 frases)',
      githubLabel: 'Usuario de GitHub (opcional)',
      githubHint: 'Opcional \u2014 nos ayuda a entender mejor tu trabajo.',
      submitButton: 'Solicitar acceso',
      submittingButton: 'Enviando\u2026',
    },
    validation: {
      nameMin: 'Por favor, introduce tu nombre',
      emailInvalid: 'Por favor, introduce un correo corporativo v\u00e1lido',
      stackMin: 'Por favor, indica tu stack',
      goalMin: 'Por favor, describe qu\u00e9 quieres verificar (al menos 10 caracteres)',
    },
    status: {
      successTitle: 'Recibido \u2014 \u00a1gracias!',
      successDetail: 'Revisaremos tu solicitud y responderemos en 2 d\u00edas laborables. Revisa tu bandeja (tambi\u00e9n el spam) para la confirmaci\u00f3n.',
      error: 'Algo sali\u00f3 mal. Int\u00e9ntalo de nuevo o escr\u00edbenos a hello@aletiq.ai.',
    },
  },
  thankYou: {
    title: 'Gracias \u2014 mensaje recibido.',
    subtitle: 'Te responderemos en 1\u20132 d\u00edas h\u00e1biles. Revisa tambi\u00e9n tu carpeta de spam.',
    backHome: 'Volver al inicio',
  },
  notFound: {
    title: 'P\u00e1gina no encontrada',
    description: 'La p\u00e1gina que buscas no existe o ha sido movida.',
    backHome: 'Volver al inicio',
  },
  footer: {
    copyright: '\u00a9 2026 Aletiq. Todos los derechos reservados.',
    builtBy: 'Creado por Denqfabrik',
    privacy: 'Pol\u00edtica de privacidad',
    terms: 'T\u00e9rminos de servicio',
    imprint: 'Aviso legal',
  },
  structuredData: {
    description:
      'Aletiq verifica autom\u00e1ticamente que las aplicaciones web generadas por IA funcionen correctamente. Doble verificaci\u00f3n para agentes de IA \u2014 seguro, r\u00e1pido, sin esfuerzo.',
    offerDescriptions: [
      'Verificaci\u00f3n autom\u00e1tica de calidad para sitios web generados por IA',
      'Doble verificaci\u00f3n: Tu agente construye, Aletiq verifica',
      'Pruebas reales en navegador con veredictos claros para tu agente',
    ],
  },
});
